export default __webpack_public_path__ + "static/media/empty_cart.d3481825.svg";